var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PopulationList',{attrs:{"label":_vm.label,"url":_vm.url},on:{"print":_vm.setPrint}}),_c('div',{staticClass:"detail"},[_c('router-view',{attrs:{"label":_vm.label,"url":_vm.url,"print":_vm.print}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }